import type { SitesBulkResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  zodSitesBulkPayloadSchema,
  zodSitesBulkResponseSchema,
} from './validations';

/**
 * Fetches sites accessible to the current user for the given IDs.
 *
 * @param siteIds - Site IDs to query. The API accepts at most 2,000 IDs.
 * @param options - Request options, including the query cancellation signal.
 * @returns Sites returned by the permission-filtered bulk endpoint.
 * @see https://app.dev.vestigas.com/redoc#tag/Site/operation/query_sites_in_bulk_site_query_bulk_post
 */
export const fetchSitesBulk = async (
  siteIds: UUID[],
  options?: KyRequestOptions,
): Promise<SitesBulkResponse> => {
  const payload = zodSitesBulkPayloadSchema.parse({ ids: siteIds });

  return vestigasApi
    .post(ENDPOINT.SITE.GET_BULK(), {
      json: payload,
      ...options,
      validate: {
        ...options?.validate,
        body: zodSitesBulkPayloadSchema,
        response: zodSitesBulkResponseSchema,
      },
    })
    .json<SitesBulkResponse>();
};
